const loadingReducer = (state = {}, action) => {
    switch (action.type) {
        case "LoadStart":
            return {
                loading: true,
                message: "",
                state: "",
            }
        case "LoadEnd":
            return {
                loading: false,
                message: action.message,
                state: action.state,
            }
        case "LoadClear":
            return {
                loading: false,
                message: "",
                state: "",
            }
        case "Purge":
            return {};
        default:
            return state;
    }
}
export { loadingReducer as loading };

const loginReducer = (state = {}, action) => {
    switch (action.type) {
        case "Login":
            localStorage.setItem('token', action.user ? action.user.accessToken : "");
            localStorage.setItem('course', action.user ? action.user.course : "");
            return {
                login: true,
                user: action.user,
                sendCount: state.sendCount,
                sendMax: state.sendMax
            }
        case "UpdateUser":
            return {
                login: state.login,
                user: action.user,
                sendCount: state.sendCount,
                sendMax: state.sendMax
            }
        case "Logout":
            localStorage.removeItem('token');
            return {
                login: false,
                user: state.user,
                sendCount: state.sendCount,
                sendMax: state.sendMax
            }
        case "ClearUserInfo":
            return {
                login: state.login,
                user: null,
                sendCount: 0,
                sendMax: 0
            }
        case "SetSendCount":
            return {
                login: state.login,
                user: state.user,
                sendCount: action.sendCount,
                sendMax: state.sendMax
            }
        case "SetSendMax":
            return {
                login: state.login,
                user: state.user,
                sendCount: state.sendCount,
                sendMax: action.sendMax
            }
        case "Purge":
            return {};
        default:
            return state;
    }
}
export { loginReducer as login };

const toppageReducer = (state = {}, action) => {
    switch (action.type) {
        case "SaveSubjectList":
            return {
                subjectList: action.subjectList,
            }
        case "Purge":
            return {};
        default:
            return state;
    }
}
export { toppageReducer as top };

const subjectReducer = (state = {}, action) => {
    switch (action.type) {
        case "LoadSubject":
            return {
                subject: action.subject,
            }
        case "Purge":
            return {};
        default:
            return state;
    }
}
export { subjectReducer as subject };

const vocabularyReducer = (state = {}, action) => {
    switch (action.type) {
        case "LoadVocabulary":
            return {
                vocabulary: action.vocabulary,
            }
        case "Purge":
            return {};
        default:
            return state;
    }
}
export { vocabularyReducer as vocabulary };

const chunkReducer = (state = {}, action) => {
    switch (action.type) {
        case "LoadChunk":
            return {
                chunk: action.chunk,
            }
        case "Purge":
            return {};
        default:
            return state;
    }
}
export { chunkReducer as chunk };

const userEditReducer = (state = {}, action) => {
    switch (action.type) {
        case "UserEdit":
            return {
                user: action.user,
            }
        case "Purge":
            return {};
        default:
            return state;
    }
}
export { userEditReducer as userEdit };

const noticeEditReducer = (state = {}, action) => {
    switch (action.type) {
        case "NoticeEdit":
            return {
                notice: action.notice,
            }
        case "Purge":
            return {};
        default:
            return state;
    }
}
export { noticeEditReducer as noticeEdit };

const recordingReducer = (state = {}, action) => {
    switch (action.type) {
        case "SaveRecord":
            return {
                records: action.records,
            }
        case "Purge":
            return {};
        default:
            return state;
    }
}
export { recordingReducer as recording };

const recoordEditReducer = (state = {}, action) => {
    switch (action.type) {
        case "RecordEdit":
            return {
                record: action.record,
            }
        case "Purge":
            return {};
        default:
            return state;
    }
}
export { recoordEditReducer as recordEdit };

const settingReducer = (state = {}, action) => {
    switch (action.type) {
        case "PlaybackRate":
            return {
                playbackRate: action.playbackRate,
                course: state.course,
                toppage: state.toppage,
                toppageScroll: state.toppageScroll,
            }
        case "Course":
            return {
                playbackRate: state.playbackRate,
                course: action.course,
                toppage: state.toppage,
                toppageScroll: state.toppageScroll,
            }
        case "TopPageDate":
            return {
                playbackRate: state.playbackRate,
                course: state.course,
                toppage: action.date,
                toppageScroll: state.toppageScroll,
            }
        case "TopPageScroll":
            return {
                playbackRate: state.playbackRate,
                course: state.course,
                toppage: state.toppage,
                toppageScroll: action.scroll,
            }
        case "Purge":
            return {};
        default:
            return state;
    }
}
export { settingReducer as setting };

const homeReducer = (state = {}, action) => {
    switch (action.type) {
        case "LoadHome":
            return {
                webInfoFlg: action.webInfoFlg,
                webAcvFlg: action.webAcvFlg,
                contentID: action.contentID,
                current: action.current,
            }
        case "Purge":
            return {};
        default:
            return state;
    }
}
export { homeReducer as home };

const videoReducer = (state = {}, action) => {
    switch (action.type) {
        case "LoadVideo":
            return {
                ctgFileName: action.ctgFileName,
                acvFileName: action.acvFileName,
            }
        case "Purge":
            return {};
        default:
            return state;
    }
}
export { videoReducer as video };

const errorReducer = (state = {}, action) => {
    switch (action.type) {
        case "ErrorInfo":
            return {
                error: {
                    display: true,
                    source: action.source,
                    code: action.statusCode,
                    info: action.error
                }
            }
        case "ErrorClear":
            return {
                error: {
                    display: false,
                    source: "",
                    code: -1,
                    info: ""
                }
            }
        case "Purge":
            return {};
        default:
            return state;
    }
}
export { errorReducer as error };
